import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChatbotLayoutComponent } from './chatbot-layout/chatbot-layout.component';
import { AdminLayoutSidebarLargeComponent } from './admin-layout-sidebar-large/admin-layout-sidebar-large.component';
import { HeaderSidebarLargeComponent } from './admin-layout-sidebar-large/header-sidebar-large/header-sidebar-large.component';
import { SidebarLargeComponent } from './admin-layout-sidebar-large/sidebar-large/sidebar-large.component';
import { FooterComponent } from '../footer/footer.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { BtnLoadingComponent } from '../btn-loading/btn-loading.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerComponent } from '../spinner/spinner.component';

const layouts = [ChatbotLayoutComponent,AdminLayoutSidebarLargeComponent, BtnLoadingComponent, SpinnerComponent];

@NgModule({
  declarations: [ChatbotLayoutComponent,AdminLayoutSidebarLargeComponent,HeaderSidebarLargeComponent,SidebarLargeComponent,FooterComponent, AuthLayoutComponent, BtnLoadingComponent, SpinnerComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule
  ],
  exports:layouts
})
export class LayoutsModule { }
